import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Psychologists from "../views/Psychologists.vue";
import Contact from "../views/Contact.vue";
import Tariffs from "../views/Tariffs.vue";
import Services from "../views/Services.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: '/psihologi',
    name: 'Psychologists',
    component: Psychologists
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/probono',
    name: 'Probono',
    component: Tariffs

  },
  {
    path: '/servicii/:name',
    name: 'Servicii',
    component: Services
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    return { x: 0, y: 0 }
  }
});

export default router;
